import i18n from "i18next";
import { reactI18nextModule } from "react-i18next";
import EstudarUA_PT from "./json/PT/EstudarUA.json";
import EstudarUA_EN from "./json/EN/EstudarUA.json";
import VidaAcademica_PT from "./json/PT/VidaAcademica.json";
import VidaAcademica_EN from "./json/EN/VidaAcademica.json";
import ChegadaAveiro_PT from "./json/PT/ChegadaAveiro.json";
import ChegadaAveiro_EN from "./json/EN/ChegadaAveiro.json";
import PrepararViagem_PT from "./json/PT/PrepararViagem.json";
import PrepararViagem_EN from "./json/EN/PrepararViagem.json";
import ProcessoIntegracao_PT from "./json/PT/ProcessoIntegracao.json";
import ProcessoIntegracao_EN from "./json/EN/ProcessoIntegracao.json";
import ToDoList_PT from "./json/PT/ToDoList.json";
import ToDoList_EN from "./json/EN/ToDoList.json";
import CidadeAveiro_PT from "./json/PT/CidadeAveiro.json";
import CidadeAveiro_EN from "./json/EN/CidadeAveiro.json";
import Faqs_PT from "./json/PT/Faqs.json";
import Faqs_EN from "./json/EN/Faqs.json";
import ContactosEmergencia_PT from "./json/PT/ContactosEmergencia.json";
import ContactosEmergencia_EN from "./json/EN/ContactosEmergencia.json";
import ContactosEstruturas_PT from "./json/PT/ContactosEstruturas.json";
import ContactosEstruturas_EN from "./json/EN/ContactosEstruturas.json";
import Homepage_PT from "./json/PT/Homepage.json";
import Homepage_EN from "./json/EN/Homepage.json";
import Sidemenu_PT from "./json/PT/Sidemenu.json";
import Sidemenu_EN from "./json/EN/Sidemenu.json";
import Footer_PT from "./json/PT/Footer.json";
import Footer_EN from "./json/EN/Footer.json";
import Page404_PT from "./json/PT/Page404.json";
import Page404_EN from "./json/EN/Page404.json";
import Construction_PT from "./json/PT/Construction.json";
import Construction_EN from "./json/EN/Construction.json";
import Botoes_PT from "./json/PT/Botoes.json";
import Botoes_EN from "./json/EN/Botoes.json";

const resources = {
  pt: {
    moduleEstudarUA: EstudarUA_PT,
    moduleVidaAcademica: VidaAcademica_PT,
    moduleChegadaAveiro: ChegadaAveiro_PT,
    modulePrepararViagem: PrepararViagem_PT,
    moduleProcessoIntegracao: ProcessoIntegracao_PT,
    moduleToDoList: ToDoList_PT,
    moduleCidadeAveiro: CidadeAveiro_PT,
    moduleFaqs: Faqs_PT,
    moduleContactosEmergencia: ContactosEmergencia_PT,
    moduleContactosEstruturas: ContactosEstruturas_PT,
    moduleHomepage: Homepage_PT,
    moduleSidemenu: Sidemenu_PT,
    moduleFooter: Footer_PT,
    modulePage404: Page404_PT,
    moduleConstruction: Construction_PT,
    moduleBotoes: Botoes_PT
  },
  en: {
    moduleEstudarUA: EstudarUA_EN,
    moduleVidaAcademica: VidaAcademica_EN,
    moduleChegadaAveiro: ChegadaAveiro_EN,
    modulePrepararViagem: PrepararViagem_EN,
    moduleProcessoIntegracao: ProcessoIntegracao_EN,
    moduleToDoList: ToDoList_EN,
    moduleCidadeAveiro: CidadeAveiro_EN,
    moduleFaqs: Faqs_EN,
    moduleContactosEmergencia: ContactosEmergencia_EN,
    moduleContactosEstruturas: ContactosEstruturas_EN,
    moduleHomepage: Homepage_EN,
    moduleSidemenu: Sidemenu_EN,
    moduleFooter: Footer_EN,
    modulePage404: Page404_EN,
    moduleConstruction: Construction_EN,
    moduleBotoes: Botoes_EN
  }
};

i18n
  .use(reactI18nextModule) // passes i18n down to react-i18next
  .init({
    resources,
    lng: "pt",
    // keySeparator: true, // we do not use keys in form messages.welcome
    
  });

export default i18n;